import { render, staticRenderFns } from "./ReceptionPatientCard.vue?vue&type=template&id=0a8f3172&scoped=true"
import script from "./ReceptionPatientCard.vue?vue&type=script&lang=js"
export * from "./ReceptionPatientCard.vue?vue&type=script&lang=js"
import style0 from "./ReceptionPatientCard.vue?vue&type=style&index=0&id=0a8f3172&prod&scoped=true&lang=css"
import style1 from "./ReceptionPatientCard.vue?vue&type=style&index=1&id=0a8f3172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8f3172",
  null
  
)

export default component.exports